import { VoidCallback } from '@deqo/foundation';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { useResolve } from '../../../Container';
import { busyPopup } from '../../../popups/BusyPopup';
import { confirmPopupWith } from '../../../popups/OptionsPopup';
import { PopupManager } from '../../../popups/PopupManager';

const deleteConfirmationPopup = () => confirmPopupWith(
    'Are you sure you want to delete these models?',
    'You can add them again later if you need.',
);

export const useOnBulkDeleteLlmInstances = (ids: string[], onOpen?: VoidCallback) => {

    const popups = useResolve(PopupManager);
    const api = useResolve(ApiClient);
    const qc = useQueryClient();

    return useCallback(async () => {

        onOpen?.();

        const { actioned, data } = await popups.invoke(deleteConfirmationPopup());
        if (!actioned || !data) return;

        await popups.invoke(busyPopup(
            async () => {
                await api.exec(v2.llm.instances.delete({ ids }));
                await qc.invalidateQueries(['llm.instances.list']);
            }
        ));

    }, [ids, onOpen]);

};
